<template>
  <section class="members-in-cities">
    <div class="container">
      <img
        v-router-link="{ name: 'CityList' }"
        src="@/assets/img/Map-Desktop.png"
        class="map-image-desktop m-auto"
      />
      <img
        v-router-link="{ name: 'CityList' }"
        src="@/assets/img/Map-Mobile.png"
        class="map-image-mobile m-auto"
      />
      <div class="text-center">
        <cs-button
          :to="{ name: 'CityList' }"
          variant="primary"
          fill="solid"
          size="medium"
          >Explore Chapters</cs-button
        >
      </div>
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.members-in-cities {
  padding: 40px 0;
  @include media-breakpoint-up(lg) {
    padding: 60px 0;
  }
  background: #fff;
  h2 {
    max-width: 250px;
    margin: 0 auto;
    margin-bottom: 20px;
    text-align: center;
  }

  a {
    margin-top: 30px;
    margin-bottom: 30px;
    text-align: center;
    @include media-breakpoint-up(lg) {
      margin-bottom: 50px;
    }
  }

  .map-image {
    &-mobile {
      max-width: 100%;
      display: block;
      @include media-breakpoint-up(md) {
        display: none;
      }
    }
    &-desktop {
      max-width: 100%;
      display: none;
      @include media-breakpoint-up(md) {
        display: block;
      }
    }
  }
  .row {
    > div {
      @include media-breakpoint-down(sm) {
        &:nth-of-type(2),
        &:nth-of-type(3) {
          display: none;
        }
      }
      @include media-breakpoint-down(md) {
        &:nth-of-type(3) {
          display: none;
        }
      }
    }
  }
  .card {
    color: #505b64;

    @include media-breakpoint-up(md) {
      padding: 40px;

      &:hover {
        box-shadow: -10px 20px 35px #00000015;
        border-radius: 5px;
      }
    }

    svg {
      fill: #3e4041;
      margin-left: -20px;
    }

    p {
      font-size: 16px;
      line-height: 32px;
      @include media-breakpoint-up(md) {
        font-size: 18px;
      }
    }

    cite {
      font-size: 17px;
      margin-top: 10px;
      font-style: normal;
      @include media-breakpoint-up(md) {
        margin-top: 30px;
      }
    }

    img {
      width: 52px;
      height: 52px;
    }

    div {
      vertical-align: middle;
    }
  }
}
</style>
